import { render, staticRenderFns } from "./SettingsAddressbookShare.vue?vue&type=template&id=51c577ef&"
import script from "./SettingsAddressbookShare.vue?vue&type=script&lang=js&"
export * from "./SettingsAddressbookShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports